import { connect } from 'react-redux'
import config from '../../config.json'
import toJS from '../general/toJS.js'
import PageSignageLitePage from '../../components/PageSignageLite/PageSignageLitePage.jsx';
import getData from '../../functions/getData.js';
import { CLI_CINEMA_CLIENT_ID, CLI_CURRENT_CINEMA_ID, PROGRAM_ATTRIBUTES, PROGRAM_CINEMAS, PROGRAM_CLI_MOVIES_ITEMS, ROUTES_DATA } from '../../constants/state.js';
import sortCinemas from '../../functions/sortCinemas.jsx';
import getMovieSortedByTitle from '../../functions/getMoviesSortedByTitle.js';

const mapStateToProps = state => ({
    clientCinemaId: getData(state, CLI_CINEMA_CLIENT_ID),
    cinemas: getData(state, PROGRAM_CINEMAS),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    routesData: getData(state, ROUTES_DATA),
    currentFrontCinemaId: getData(state, CLI_CURRENT_CINEMA_ID),
    currentLang: state.getIn(['translation', 'currentLang']),
    movieData: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
})

const PageSignageLite = ({cinemas, attributes, routesData, currentFrontCinemaId, movieData, currentLang, clientCinemaId}) => {
    const cliCinemasIdList = sortCinemas(clientCinemaId, cinemas)

    return (
        <PageSignageLitePage
            pageName={config.routes.signagelite.name}
            cinemas={cinemas}
            currentLang={currentLang}
            clientCinemaId={clientCinemaId}
            currentFrontCinemaId={currentFrontCinemaId}
            routesData={routesData}
            cliCinemasIdList={cliCinemasIdList}
            attributes={attributes}
            movieData={movieData}
            sortedMovieDataKeys={getMovieSortedByTitle(movieData)}
        />
    )
}

export default connect(mapStateToProps)(toJS(PageSignageLite))